import request from '@/utils/request'
const url = 'index.php/bazaar/api/bazaar/'



/**
 * 热门排行
 * @param query
 * @constructor
 */
export function GetCourseItemHot(query) {
    return request({
        url: url +'Course/GetCourseItemHot',
        method: 'get',
        params: query
    })
}


/**
 * 新课排行
 * @param query
 * @constructor
 */
export function GetCouresItemNewRanking(query) {
    return request({
        url: url +'Course/GetCouresItemNewRanking',
        method: 'get',
        params: query
    })
}

/**
 * 五星排行
 * @param query
 * @constructor
 */
export function GetCourseItemFiveStar(query) {
    return request({
        url: url +'Course/GetCourseItemFiveStar',
        method: 'get',
        params: query
    })
}


/**
 * 选课中心列表
 * @param query
 * @constructor
 */
export function GetCourseItemByData(query) {
    return request({
        url: url +'Course/GetCourseItemByData',
        method: 'get',
        params: query
    })
}



//课程播放列表内容
export function GetItemByData(query) {
    return request({
        url: url +'Course/GetItemByData',
        method: 'get',
        params: query
    })
}

//课程详情
export function GetInfoById(query) {
    return request({
        url: url +'Course/GetInfoById',
        method: 'get',
        params: query
    })
}


//课程断点
export function GetUserCourseByLog(data) {
    return request({
        url: url +'Course/GetUserCourseByLog',
        method: 'post',
        data
    })
}


//课程播放结束提交记录
export function PostUserCourseByOver(data) {
    return request({
        url: url +'Course/PostUserCourseByOver',
        method: 'post',
        data
    })
}

//提交人脸核验照片
export function PostUserFaceByPhoto(data){
    return request({
        url: url +'Course/PostUserFaceByPhoto',
        method: 'post',
        data
    })
}


//人脸识别
export function PostFaceRecognition(data){
    return request({
        url: url +'Course/PostFaceRecognition',
        method: 'post',
        data
    })
}



//查询一下这个课程所在的期号被关闭没有
export function GetShutDownStatus(issue_id) {
    return request({
        url: url +'Course/GetShutDownStatus',
        method: 'get',
        params: {issue_id}
    })
}

